/**
 * The "Regenerate title" entry in a thread's context menu.
 *
 * Kept as a pure builder so the disabled-while-running rule is testable
 * without standing up the native context-menu bridge.
 *
 * @module threadTitleRegenerationMenu
 */
export interface ThreadTitleRegenerationMenuItem {
  readonly id: "regenerate-title";
  readonly label: string;
  readonly disabled?: true;
}

/**
 * Disabled rather than hidden while a regeneration is in flight: an item that
 * disappears on click reads as the menu losing the action, and re-firing it
 * would start a second request that immediately supersedes the first.
 */
export function buildThreadTitleRegenerationMenuItem(input: {
  readonly isRegenerating: boolean;
}): ReadonlyArray<ThreadTitleRegenerationMenuItem> {
  return input.isRegenerating
    ? [{ id: "regenerate-title", label: "Regenerating…", disabled: true }]
    : [{ id: "regenerate-title", label: "Regenerate title" }];
}
